import { Chip, ChipOwnProps } from "@mui/material";
import { SyntheticEvent } from "react";

export type StateChipProps = {
  color: string;
  label: string;
  size?: ChipOwnProps["size"];
  onDelete?: (event: SyntheticEvent) => void;
};

export function StateChip({
  color,
  label,
  size = "small",
  onDelete,
}: StateChipProps) {
  return (
    <Chip
      size={size}
      label={label}
      onDelete={onDelete}
      sx={[
        {
          backgroundColor: "transparent",
          border: `1px solid ${color}`,
          color: color,
        },
        (theme) =>
          theme.applyStyles("dark", {
            backgroundColor: "background.paper",
            border: "unset",
            color: color,
            // backgroundColor: color,
            // borderColor: "background.paper",
            // color: theme.palette.getContrastText(color),
          }),
      ]}
    />
  );
}
